import { Box, Skeleton } from '@factorialco/deprecated-design-system'

import { Tag } from 'modules/cost_centers/components/CostCenterAllocations/Tag'
import useCostCentersAssignments from 'modules/cost_centers/hooks/useCostCentersAssignments'

interface ReferenceAssignmentTagsProps {
  selectedOption?: { value: string; resourceId?: string }
  resourceDate: string
  selectedOptionIsResource: boolean
  hasNewStructureEnabled?: boolean
}

export const ReferenceAssignmentTags = ({
  selectedOption,
  resourceDate,
  selectedOptionIsResource,
  hasNewStructureEnabled = false,
}: ReferenceAssignmentTagsProps) => {
  const { assignments: referenceAssignments, isLoading: loadingReferenceAssignments } =
    useCostCentersAssignments({
      resourceType: selectedOption?.value || '',
      resourceId: String(selectedOption?.resourceId),
      applyingOn: resourceDate,
      skipQueries:
        !selectedOption?.resourceId || !selectedOption?.value || selectedOptionIsResource,
      hasNewStructureEnabled,
    })

  if (loadingReferenceAssignments) {
    return (
      <Box gap="s8" flexDirection="row">
        {Array.from({ length: 3 }).map((_, index) => (
          <Skeleton key={index} width="s96" height="s24" />
        ))}
      </Box>
    )
  }

  return (
    <Box gap="s8" flexDirection="row">
      {referenceAssignments.map((assignment, index) => (
        <Tag
          key={assignment.id}
          costCenterName={assignment.costCenter?.name ?? ''}
          percentage={`${(Number(assignment.percentage) * 100).toFixed(2)}`}
          index={index}
        />
      ))}
    </Box>
  )
}
